import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../../../../../reducers/types";
import { ConfirmationModalPackageContent } from "./component";
import { getAirlinesMap } from "../../../../../../reducer";

const mapStateToProps = (state: IStoreState) => ({
  airlineMap: getAirlinesMap(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ConfirmationModalPackageContentConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedConfirmationModalPackageContent = connector(
  ConfirmationModalPackageContent
);
